// extracted by mini-css-extract-plugin
export default {"root":"MenuLanguagesItem_root__9PGSb","active":"MenuLanguagesItem_active__vmoCo","insert":"MenuLanguagesItem_insert__vvfmX"};